import { nanoid } from 'nanoid';

import type { PaddingProperty, PlacableComponent } from '../types';

export interface HeadingProps<Value = string> extends PlacableComponent {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  padding?: PaddingProperty;
  type: 'HEADING';
  value: Value;
}

export function Heading({ level, padding, value }: HeadingProps) {
  const style = {
    paddingTop: padding?.top,
    paddingRight: padding?.right,
    paddingBottom: padding?.bottom,
    paddingLeft: padding?.left
  };

  switch (level) {
    case 2:
      return (
        <h2 className="m-0" style={style}>
          {value}
        </h2>
      );
    case 3:
      return (
        <h3 className="m-0" style={style}>
          {value}
        </h3>
      );
    case 4:
      return (
        <h4 className="m-0" style={style}>
          {value}
        </h4>
      );
    case 5:
      return (
        <h5 className="m-0" style={style}>
          {value}
        </h5>
      );
    case 6:
      return (
        <h6 className="m-0" style={style}>
          {value}
        </h6>
      );
    default:
      return (
        <h1 className="m-0" style={style}>
          {value}
        </h1>
      );
  }
}

export function headingPropsFactory(): HeadingProps {
  return {
    id: nanoid(10),
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    type: 'HEADING',
    level: 1,
    value: 'New Heading'
  };
}
